import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../Environments/environment.dev';
import { AppointmentRequestPayload } from '../../app/PatientReferral/patient-referral/interface';
import { Observable, shareReplay, catchError, of, BehaviorSubject, delay } from 'rxjs';
import { City, InsurancePayorResponse } from '../../app/PatientOnboarding/patientonboarding/interface';
import { CheckAppointmentStatus, DoctorsListByVisitReason, OnlineAppointment, OrgDorctorLeaveDates, RequestCallBack } from '../../app/BookAppointment/book-appointment/interface';
import { PersonalDetailsForm } from '../../app/PatientLogin/login/interface';
import { BaseApiService } from '../../Shared/utilities';

@Injectable({
  providedIn: 'root',
})
export class Ehnoteparent extends BaseApiService {
  //extends BaseApiService entend this if when use token for authentication
  private baseUrl = environment.apiUrl;
  private aiApiUrl = environment.aiApiUrl;
  //super(); add it inside constructor
  constructor(private http: HttpClient) { super(); }
  // private cache = new Map<string, { expiry: number, data$: Observable<any> }>();
  // private CACHE_TIME = 5 * 60 * 1000;

  // private getCachedRequest(key: string, apiCall$: Observable<any>): Observable<any> {
  //   const now = Date.now();
  //   if (this.cache.has(key)) {
  //     const entry = this.cache.get(key)!;
  //     if (entry.expiry > now) return entry.data$;
  //     this.cache.delete(key);
  //   }
  //   const shared$ = apiCall$.pipe(shareReplay(1));
  //   this.cache.set(key, { expiry: now + this.CACHE_TIME, data$: shared$ });
  //   return shared$;
  // }
  // end of reusable code

  // ------------------ SERVICE METHODS ------------------

  uploadReferralRequest(model: any, files: File[]): Observable<any> {
    const formData = new FormData();
    formData.append("model", JSON.stringify(model));
    files.forEach(file => formData.append("file", file));

    return this.http.post(
      `${this.baseUrl}/Patient/ReferralRequestFromPatientPlugin`,
      formData
    );
  }

  getSubOrganizationsListbyId(parentOrganizationId: number) {
    return this.http.get(
      `${this.baseUrl}/Patient/getSubOrganizationsListbyId`,
      {
        params: new HttpParams().set(
          'parentOrganizationId',
          parentOrganizationId
        )
      }
    );
  }

  GetPatientRelatedMasterData() {
    return this.getCachedRequest(
      'patient-related-master-data',
      this.http.get(`${this.baseUrl}/MasterData/GetPatientRelatedMasterData`)
    );
  }

  //New Online Appointment Sevice
  GetOnlineAppointmentVisitReasons(params: any) {
    return this.http.post(`${this.baseUrl}/Setting/GetOnlineAppointmentVisitReasons`, params);
  }

  GetAllUsersByDeptId(reqObj: any) {
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/MasterAdmins/GetAllUsersByDeptId`, reqObj)
    );
  }

  /**
   * Provider list for the online appointment flow, scoped to the selected
   * Visit Category (= Visit Reason). Replaces GetAllUsersByDeptId as the source
   * of the Book Appointment provider dropdown, so the list changes whenever the
   * selected visit reason changes.
   */
  GetDoctorsListByVisitReasonId(reqObj: DoctorsListByVisitReason) {
    return this.getCachedRequest(
      `doctors-by-visit-reason-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/MasterAdmins/GetDoctorsListByVisitReasonId`, reqObj)
    );
  }
  getOnlineSlotByDcotorId(reqObj: any) {
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/Admin/GetUserScheduledSlots`, reqObj)
    );
  }

  GetOrganizationandUserHolidayList(reqObj: OrgDorctorLeaveDates) {
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/Patient/GetDoctorSlotsByVisitReasons`, reqObj)
    );
  }

  GetDoctorAvaiableSlotByDate(reqObj: any) {
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/Patient/GetDoctorAvaiableSlotByDate`, reqObj)
    );
  }
  GetDoctorAvailableOnlineSlotByDate(reqObj: any) {
    return this.http.post(`${this.baseUrl}/Patient/GetDoctorAvaiableOnlineSlotByDate`, reqObj)
  }
  AddupdateOnlineAppointment(payload: OnlineAppointment) {
    return this.http.post(
      `${this.baseUrl}/Patient/AddupdateOnlineAppointment`,
      payload
    );
  }

  // ------------------ OTP ------------------

  /** OTP Request (public: no auth required) */
  GenerateOtpForPatientPortal(ReqObj: {
    MobileNumber?: string;
    EmailId?: string;
    CountryCode?: string;
    OrganizationName?: string;
  }) {
    const params = new HttpParams()
      .set('MobileNumber', ReqObj.MobileNumber ?? '')
      .set('EmailId', ReqObj.EmailId ?? '')
      .set('CountryCode', ReqObj.CountryCode ?? '')
      .set('OrganizationName', ReqObj.OrganizationName ?? '');

    return this.http.get(`${this.baseUrl}/MasterPatient/GenerateOtpForPatientPortal`, { params });
  }
  GenerateOtpForPatientPortalToEmail(reqObj: {
    EmailId: string;
    PatientName: string;
    EmailCommunicationEnabled: boolean;
    HospitalID: number;
    OrganizationName: string;
  }) {
    return this.http.post(
      `${this.baseUrl}/MasterPatient/GenerateOtpForPatientPortalToEmail`,
      reqObj
    );
  }
  GenerateOtpForPatientPortalwithoutRegistration(ReqObj: {
    MobileNumber?: string;
    EmailId?: string;
    CountryCode?: string;
    OrganizationName?: string;
  }) {
    const params = new HttpParams()
      .set('MobileNumber', ReqObj.MobileNumber ?? '')
      .set('EmailId', ReqObj.EmailId ?? '')
      .set('CountryCode', ReqObj.CountryCode ?? '')
      .set('OrganizationName', ReqObj.OrganizationName ?? '');

    return this.http.get(`${this.baseUrl}/MasterPatient/GenerateOtpForPatientPortalwithoutRegistration`, { params });
  }

  /** OTP Validation (secured, depends on API rules) */
  ValidatePatientAppOTP(ReqObj: { reqMobileNo?: string; Otp?: string; SubOrganizationId?: number }) {
    const params = new HttpParams()
      .set('MobileNumber', ReqObj.reqMobileNo ?? '')
      .set('OTP', ReqObj.Otp ?? '')
      .set('SubOrganizationId', String(ReqObj.SubOrganizationId ?? ''));

    return this.http.get(
      `${this.baseUrl}/MasterPatient/USValidatePatientAppOTPForWeb`,
      { params }
    );
  }

  ValidatePatientQRAppOTPToEmailId(ReqObj: { reqEmail?: string; Otp?: string; ParentOrganizationId?: number }) {
    const params = new HttpParams()
      .set('EmailId', ReqObj.reqEmail ?? '')
      .set('OTP', ReqObj.Otp ?? '')
      .set('ParentOrganizationId', String(ReqObj.ParentOrganizationId ?? ''));

    return this.http.get(
      `${this.baseUrl}/MasterPatient/ValidatePatientQRAppOTPToEmailId`,
      { params }
    );
  }

  GetAuthtokenForAppoinmentPlugin() {
    return this.http.get(
      `${this.baseUrl}/MasterPatient/GetAuthtoken`
    );
  }

  // ------------------ APPOINTMENTS ------------------

  RequestAppointment(payload: AppointmentRequestPayload) {
    return this.http.post(
      `${this.baseUrl}/Patient/RequestAppointmentPlugIn`,
      payload
    );
  }
  AddUpdatePatientDetails(payload: PersonalDetailsForm) {
    return this.http.post(
      `${this.baseUrl}/Patient/AddUpdatePatientDetailsFromAppointmetPlugin`,
      payload
    );
  }
  AppointmentReasonRemarksFrompatientPortal(reqObj: RequestCallBack) {
    const reqjson = JSON.stringify(reqObj);
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/Patient/AppointmentReasonRemarksFrompatientPortal`, JSON.stringify(reqjson))
    );
  }
  CheckAppointmentstatus(reqObj: CheckAppointmentStatus) {
    const reqjson = JSON.stringify(reqObj);
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/Consultation/CheckAppointment`, reqObj)
    );
  }
  GetDoctorNextAvaiableSlot(reqObj: any) {
    const reqjson = JSON.stringify(reqObj);
    return this.getCachedRequest(
      `users-${JSON.stringify(reqObj)}`,
      this.http.post(`${this.baseUrl}/Patient/GetDoctorNextAvaiableSlotPlugin`, reqObj)
    );
  }

  //------------------ Patient Potal ------------------//

  //My-Visits
  getLatestAppointmentsBySelectedDates(params: any): Observable<any> {
    const param = JSON.stringify(params);
    const paramss = "'" + param + "'";
    return this.http.post<any>(
      `${this.baseUrl}/AppointmentPlugin/GetLatestAppointmentsBySelectedDates`,
      params
    );
  }

  //Forms
  getLatestAppointmentsForOnBoardingForm(payload: any) {
    return this.http.post<any>(
      `${this.baseUrl}/AppointmentPlugin/GetLatestAppointmentsForOnBoardingForm`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  //Logs
  getPatientPortalLogs(payload: any) {
    return this.http.post<any>(
      `${this.baseUrl}/Consultation/GetPatientPortalLogs`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  //prescriptions
  getPrescriptionAppointmentsByPatientId(payload: any) {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/GetPrescriptionAppointmentsByPatientId`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  //Profile_Document-Tab
  getPatientDocumentDetails(payload: any) {
    return this.http.post<any>(
      `${this.baseUrl}/Consultation/GetPatientPortalDocumentDetails`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  }

  //------------------------ Patient Onboarding --------------------------------------//

  getCities(stateId: number): Observable<City[]> {
    const params = new HttpParams().set('StateId', stateId);
    return this.getCachedRequest(
      `cities-${stateId}`,
      this.http.get<City[]>(
        `${this.baseUrl}/MasterData/GetCitiesById`,
        { params }
      )
    );
  }

  addUpdatePatientDemographicsDetailsFromPatientPortal(
    params: any
  ): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/AddUpdatePatientDemographicsDetailsFromPatientPortl`,
      params
    );
  }

  processPaymennt(
    params: any
  ): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/NMIPayment/PaymentProcessByPatient`,
      params
    );
  }

  GetpatientClaimInfo(params: any) {
    return this.http.get(
      `${this.baseUrl}/NMIPayment/GetpatientClaimInfo`,
      {
        params: new HttpParams()
          .set('patientId', params.PatientId)
          .set('parentOrganizationId', params.ParentOrganizationId)
      }
    );
  }

  verifyPatientForBillPay(params: {
    PatientName: string;
    PatientDisplayId: string;
    EmailId: string;
    MobileNo: string;
    ParentOrganizationId?: number | null;
  }): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/NMIPayment/VerifyPatientForBillPay`,
      params
    );
  }

  GetValiadatePatientDetails(params: {
    FirstName: string;
    LastName: string;
    DOB: string;
    Gender: string;
    EmailId: string;
    PatientMrNo: string;
    MobileNumber: number;
    ParentHospitalId: number | null;
  }): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/GetValiadatePatientDetails`,
      params
    );
  }

  processDepositPayment(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/NMIPayment/PaymentProcessandAddDepositv2`,//NMIPayment/PaymentProcessandAddDeposit_new
      params
    );
  }

  updatePatientBillingAddress(params: {
    PatientId: number;
    AddressLine1: string;
    CityName: string;
    StateCode: string;
    ZipCode: string;
  }): Observable<any> {
    return of({ status: 'Success', data: params }).pipe(delay(300));
  }

  // ------------------ Patient Validation ------------------ //
  getValidPatientDetails(PatientId: any, OrganizationId: any, AppointmentId: any): Observable<any> {
    const params = new HttpParams()
      .set('AppointmentId', AppointmentId)
      .set('organizationId', OrganizationId)
      .set('patientId', PatientId);

    return this.http.get<any>(`${this.baseUrl}/Patient/GetValidPatientDetails`, { params }).pipe(
      catchError((err) => {
        console.error('Error fetching patient details', err);
        return of(null);
      })
    );
  }
  getFrequentlyUsedCitiesByUserId(
    params: { UserId: number; SearchText: string; StateId: number }
  ): Observable<any> {
    return this.http
      .post<any>(
        `${this.baseUrl}/MasterData/getFrequentlyUsedCitiesByUserId`,
        params
      )
  }

  SearchCity(key: string): Observable<any> {
    const params = new HttpParams().set('key', key);

    return this.http
      .get<any>(
        `${this.baseUrl}/MasterData/SearchCity`,
        { params }
      )
  }

  getCountries(): Observable<any> {
    return this.getCachedRequest(
      'countries',
      this.http.get<any>(
        `${this.baseUrl}/MasterData/GetAllCountries`
      )
    )
  }

  GetLocationsByZipCode(zipCode: string): Observable<any> {
    const params = new HttpParams().set('ZipCode', zipCode);

    return this.http
      .get<any>(
        `${this.baseUrl}/MasterData/GetLocationsByZipCode`,
        { params }
      )
  }
  //  validatePatient(PatientId: number, OrganizationId: number, AppointmentId: number): Observable<boolean> {
  //    return this.getValidPatientDetails(PatientId, OrganizationId, AppointmentId).pipe(
  //      map((res: any) => {
  //        if (!res) return false;

  //        if (res.IsValidPatient !== undefined) {
  //          this.token = res.Token || '';

  //          return res.IsValidPatient === true;
  //        }
  //        if (res.rows && res.rows.length > 0) {
  //          const patient = res.rows[0];
  //          return patient.PatientId > 0 && patient.OrganizationId > 0 && patient.AppointmentId > 0;
  //        }

  //        return false;
  //      }),
  //      catchError(() => of(false))
  //    );
  //  }

  private patientAppointmentConsentsSource = new BehaviorSubject<any[]>([]);
  patientAppointmentConsents$ = this.patientAppointmentConsentsSource.asObservable();
  setPatientAppointmentConsents(consents: any[]) {
    this.patientAppointmentConsentsSource.next(consents || []);
  }

  getBranchSubSpecializationsById(subOrgId: number, branchId: number): Observable<any> {
    const body = {
      SubOrganizationId: subOrgId,
      BranchId: branchId
    };

    return this.http.post<any>(
      `${this.baseUrl}/MasterAdmins/GetBranchSubSpecializationsById`,
      body
    );
  }

  getAllUsersByDepartmentId(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/MasterAdmins/GetAllUsersByDeptId`,
      params
    );
  }

  getReferalPCPDoctors(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/CareTeam/GetReferalPCPDoctors`,
      params
    );
  }

  //Concerns service
  addUpdatePatientSignedConsentsFromPatientPortal(params: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/AddUpdatePatientSignedConsentsFromPatientPortal`,
      params
    );
  }

  addUpdateROSDataFromPatientPortal(rosObj: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/AddupdateROSDataFrompatientPortal`,
      rosObj
    );
  }

  // Insurance Service
  getOrganizationInsurancePayorsList(params: any): Observable<InsurancePayorResponse> {
    return this.http.post<InsurancePayorResponse>(
      `${this.baseUrl}/Insurance/GetOrganizationInsurancePayorsList`,
      params,

    );
  }
  GetOrganizationPayorPlansList(params: any): Observable<InsurancePayorResponse> {
    return this.http.post<InsurancePayorResponse>(
      `${this.baseUrl}/Insurance/GetOrganizationPayorPlans`,
      params
    );
  }

  GetAllFrequentlyAddedData(allergiesreq: any) {
    return this.getCachedRequest(
      'frequently-added-data',
      this.http.post(
        `${this.baseUrl}/MasterData/GetAllFrequentlyAddedData`,
        allergiesreq
      )
    );
  }

  GetAllMasterConsultationData(): Observable<any> {
    return this.getCachedRequest(
      'master-consultation-data',
      this.http.get(
        `${this.baseUrl}/MasterData/GetAllMasterConsultationData`
      )

    );
  }

  getListOfAllergies(payload: any) {
    return this.http.get<any>(
      `${this.baseUrl}/MasterData/getListofAllergies`,
      {
        params: payload
      }
    );
  }

  GetMasterSystemicHistory(payload: any) {
    return this.http.post<any>(
      `${this.baseUrl}/MasterData/GetMasterSystemicHistory`,
      payload
    );
  }

  GetOrganizationMedications(payload: any) {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/GetOrganizationMedications`,
      payload
    );
  }

  addUpdatePatientInsurancesFromPatientPortal(param: any): Observable<any> {

    const formData = new FormData();

    // map temp array to backend model
    if (param?.PatientInsuranceDetails?.length) {
      param.PatientInsuranceDetails.forEach((ins: any) => {

        ins.PatientDocumentDetails = (ins.TempInsuranceImagesArray || []).map((doc: any) => ({
          ...doc,
          S3URL: doc.S3URL || "temp"   // prevent API from removing the item
        }));

      });
    }

    formData.append('model', JSON.stringify(param));

    const docs =
      param?.PatientInsuranceDetails?.[0]?.TempInsuranceImagesArray || [];

    docs.forEach((doc: any, i: number) => {

      if (doc.DocumentId === 0 && doc.file instanceof File) {

        const ext = doc.file.name.split('.').pop();
        const finalName = (doc.DisplayName || 'File') + '.' + ext;

        formData.append('file' + (i + 1), doc.file, finalName);
      }

    });

    return this.http.post(
      `${this.baseUrl}/Patient/AddupdatePatientInsurancesFromPatientportal`,
      formData
    );
  }

  addUpdatePatientRegisterFromPatientPortal(
    param: any,
    param1: any
  ): Observable<any> {

    const formData = new FormData();
    // model
    formData.append('model', JSON.stringify(param));
    // file1 -> referral document
    const referralFiles = param1?.referralDocumentDetails || [];
    referralFiles.forEach((item: any) => {
      if (item?.file instanceof File) {
        formData.append('file1', item.file, item.file.name);
      }
    });
    // file2 -> profile image
    const files = param1?.patientProfilePicDetails || [];
    files.forEach((item: any) => {
      if (item?.file instanceof File) {
        formData.append('file2', item.file, item.file.name);
      }
    });
    // DEBUG
    formData.forEach((value, key) => {
      console.log(key, value);
    });

    return this.http.post(
      `${this.baseUrl}/Patient/AddUpdatePatientRegisterFromPatientPortal`,
      formData
    );
  }
  deletePatientInsuranceDetails(obj: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/Patient/DeletePatientInsuranceDetails`,
      obj
    );
  }
  PatientFinalReviewSignFromPatientPortal(obj: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/Patient/PatientFinalReviewSignFromPatientPortal`,
      obj
    );
  }

  generatePortalLoginToken(subOrgCode: string, hospitalId: number, organizationId: number): Observable<string> {
    return this.http.get<string>(
      `${this.baseUrl}/Patient/GetEncryptedPatientPortalLoginToken`,
      {
        params: {
          subOrgCode,
          hospitalId,
          organizationId
        }
      }
    );
  }
  UsMobileFormatChange(data: string | null | undefined): {
    MobileNumber: string;
    UsFormatMobileNumber: string;
  } {

    let USnumberString = data || '';
    let UsFormatMobileNumber = '';

    if (USnumberString !== '') {

      const digits = USnumberString.replace(/\D+/g, '');

      const match = digits.match(/.{1,10}$/)?.[0] || '';

      const part1 = match.length > 3
        ? `(${match.substring(0, 3)})`
        : match;

      const part2 = match.length > 3
        ? ` ${match.substring(3, 6)}`
        : '';

      const part3 = match.length > 6
        ? `-${match.substring(6, 10)}`
        : '';

      UsFormatMobileNumber = part1 + part2 + part3;
    }

    return {
      MobileNumber: USnumberString,
      UsFormatMobileNumber
    };
  }

  // getOrgEducationalMaterialsById(params:any): Observable<any> {

  //   const body = `'${JSON.stringify(params)}'`;

  //   return this.http.post(
  //     `${this.baseUrl}/Surgery/GetOrgEducationalMaterialsById`,
  //     body,
  //     {
  //       headers: {
  //         'Content-Type': 'application/json'
  //       }
  //     }
  //   );
  // }
  getPatientSurgeryDocuments(params: any): Observable<any> {
    const body = JSON.stringify(params);

    return this.http.post(
      `${this.baseUrl}/Patient/GetPatientSurgeryDocument`,
      body,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
  }
  addUpdatePluginAppointmentRequest(params: any) {
    return this.http.post(`${this.baseUrl}/AppointmentPlugin/AddUpdatePluginAppointmentRequest`, params);
  }

  getPatientAppointmentConsentsById(params: any) {
    return this.http.post(`${this.baseUrl}/Setting/GetPatientAppointmentConsentsById`, params);
  }

  getPatientAppointmentConsentFieldsData(params: any) {
    return this.http.post(`${this.baseUrl}/Consultation/GetPatientAppointmentConsentFieldsData`, params);
  }
  getMedicineDosageFieldsMasterData() {
    return this.http.get(`${this.baseUrl}/MasterData/GetMedicineDosageFieldsMasterData`);
  }

  ProcessInsuranceCard(params: any) {
    return this.http.post(
      `${this.aiApiUrl}/documents/insurance-card`,
      {
        base64Content: params.base64Content,
        contentType: params.contentType,
        sessionId: params.sessionId
      }
    );
  }

  ProcessIdCard(params: any) {
    return this.http.post(
      `${this.aiApiUrl}/documents/id-card`,
      {
        base64Content: params.base64Content,
        contentType: params.contentType,
        sessionId: params.sessionId
      }
    );
  }
}
